<br>

<div class="card card-default">
    <div class="card-header title_size">
        <h2 class="card-title">Edit Employee Details</h2>
        <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
            </button>
            <button type="button" class="btn btn-tool" data-card-widget="remove">
                <i class="fas fa-times"></i>
            </button>
        </div>
    </div>


    <mat-tab-group>
        <mat-tab label="Employee Details">
            <div class="card-body">

                <div class="row">
                    <div class="col-md-6">

                        <div class="form-group">
                            <label>Code</label>
                            <input type="text" class="form-control" name="code" [(ngModel)]="data.employee_code">
                        </div>
                        <div class="form-group">
                            <label>Role</label>
                            <!-- <input type="text" class="form-control" name="role" [(ngModel)]="data.role"> -->
                            <select class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                                data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.role">
                                <option selected="selected" data-select2-id="1">{{data.role}}</option>
                                <option>Admin</option>
                                <option>Employee</option>
                                <option>Factory_Manager</option>
                                <option>Delivery_Man</option>
                                <option>Manager</option>
                                <option>Salesman</option>
                                <option>Sales_Promoter</option>
                                <option>Manager_Pro</option>
                                <option>Department_Foreman</option>
                                <option>Technician</option>
                                <option>Helper</option>
                                <option>Mixer</option>
                                <option>BDM</option>
                                <option>Sales_Executive</option>
                                <option>india_sales_promoter</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Monthly Receipt Target</label>
                            <input type="number" class="form-control" name="receiptTarget"
                                [(ngModel)]="data.monthly_receipts_target">
                        </div>
                        <div class="form-group">
                            <label>Yearly Receipt Target</label>
                            <input type="number" class="form-control" name="receiptTarget"
                                [(ngModel)]="data.current_year_receipt_target">
                        </div>
                        <div class="form-group">
                            <label>Today Visit Target</label>
                            <input type="number" class="form-control" name="todayTarget"
                                [(ngModel)]="data.today_visit_target">
                        </div>
                        <div class="form-group">
                            <label>Current Month Visit Target</label>
                            <input type="number" class="form-control" name="monthTarget"
                                [(ngModel)]="data.current_month_visits_target">
                        </div>

                        <div class="form-group">
                            <label>KPI</label>
                            <input type="number" class="form-control" name="kpi" [(ngModel)]="data.default_kpi_value">
                        </div>
                        <!---------------upload image-------------------------------------->

                        <div class="form-group">
                            <label>Image</label>
                            <input type="search" class="form-control" name="role" [(ngModel)]="name"
                                (change)="RemoveFile()">
                        </div>
                        <div class="custom-file">
                            <input #imageInput type="file" class="custom-file-input" id="customFile" accept="image/*"
                                (change)="processFile(imageInput)" [(ngModel)]="currentInput">
                            <label class="custom-file-label" for="customFile">{{currentInput}}</label>
                        </div>



                    </div>
                    <!---------------------------------------------next row-------------------------------------->
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" class="form-control" name="name" [(ngModel)]="data.employee_name">
                        </div>

                        <div class="form-group">
                            <label>Email</label><span class="error">{{EmailAlert}}</span>
                            <input type="email" class="form-control" name="email" [(ngModel)]="data.email_address"
                                [formControl]="email" (ngModelChange)="valuechange1($event)">
                        </div>

                        <div class="form-group">
                            <label>Mobile</label>
                            <input type="number" class="form-control" name="mob" [(ngModel)]="data.mobile">
                        </div>

                        <div class="form-group">
                            <label>Monthly Sales Target</label>
                            <input type="number" class="form-control" name="invoiceTarget"
                                [(ngModel)]="data.monthly_invoice_target">
                        </div>

                        <div class="form-group">
                            <label>Yearly Sales Target</label>
                            <input type="number" class="form-control" name="invoiceTarget"
                                [(ngModel)]="data.current_year_sales_target">
                        </div>

                        <div class="form-group">
                            <label>Department</label>
                            <!--
                    <select  #teams (change)="onSelected(teams.value)" class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.department">
                -->
                            <select #teams class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                                data-select2-id="1" tabindex="-1" aria-hidden="true"
                                (change)="selectedDepartmen(teams.value)">
                                <option selected="selected" data-select2-id="1">{{data.department}}</option>
                                <option *ngFor="let d of department" data-select2-id="2"
                                    [value]="d.department_name+','+d.department_id">
                                    {{d.department_name}}</option>
                                <span class="select2-selection__arrow" role="presentation"><b
                                        role="presentation"></b></span>
                            </select>
                        </div>



                        <div class="form-group">
                            <label>Company Brand</label>
                            <select class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                                data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.company_brand">
                                <option selected="selected" data-select2-id="1">{{data.company_brand}}</option>
                                <option *ngFor="let d of brand" data-select2-id="2">{{d.brand_name}}</option>
                                <span class="select2-selection__arrow" role="presentation"><b
                                        role="presentation"></b></span>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Product Brand</label>

                            <select class="form-control select2 select2-hidden-accessible" style="width: 100%;"
                                data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.product_brand">
                                <option selected="selected" data-select2-id="1">{{data.product_brand}}</option>
                                <option *ngFor="let d of brand" data-select2-id="2">{{d.brand_name}}</option>
                                <span class="select2-selection__arrow" role="presentation"><b
                                        role="presentation"></b></span>
                            </select>
                        </div>
                        <!-------------------------------------------------------------------------------->
                    </div>

                </div>

            </div>

            <!-------------------Test alert---------------------->
            <div class="alert alert-success alert-dismissible alertWidth" *ngIf="isShown">
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="shown()">×</button>
                <h4><i class="icon fas fa-check"></i> {{alert}}</h4>
            </div>
            <!------------------------------------------------------------------>


            <button type="submit" style="margin-left: 50%;" class="btn btn-primary btn_allign"
                (click)="btnClick(); notification();">Submit</button><br><br>









        </mat-tab>


        <mat-tab label="KPIS">
            <div class="card-body">

                <!-- Action buttons -->
                <div class="kpi-actions-row">
                    <button mat-mini-fab color="primary" matTooltip="Add KPI" (click)="addKpi()"
                        data-target="#modal-sm3">
                        <mat-icon>add</mat-icon>
                    </button>
                    <button type="submit" class="btn btn-primary" (click)="btnClick(); notification();">Submit</button>
                </div>

                <!-- Empty state -->
                <div *ngIf="!monthlyemployeeArray || monthlyemployeeArray.length === 0" class="kpi-empty-state">
                    <mat-icon class="kpi-empty-icon">insert_chart_outlined</mat-icon>
                    <p>No KPI records yet. Click <strong>+</strong> to add one.</p>
                </div>

                <!-- KPI cards list -->
                <div class="kpi-cards-wrapper">
                    <div class="kpi-edit-card" *ngFor="let c of monthlyemployeeArray; index as i">

                        <!-- Card header -->
                        <div class="kpi-edit-card-header">
                            <span class="kpi-edit-month-label">Monthly KPI</span>
                            <span class="kpi-edit-month-value">{{ c.month_year }}</span>
                        </div>

                        <!-- Card body -->
                        <div class="kpi-edit-card-body">
                            <div class="kpi-grid">

                                <!-- Month (read-only) -->
                                <div class="kpi-field full-width">
                                    <label class="kpi-label">Month</label>
                                    <input type="text" class="form-control" [(ngModel)]="c.month_year"
                                        (change)="onMonthChange(i)" disabled>
                                </div>

                                <!-- Agreed Sales -->
                                <div class="kpi-field">
                                    <label class="kpi-label">Agreed Sales</label>
                                    <input type="number" class="form-control" [(ngModel)]="c.agreed_sales_kpi"
                                        (ngModelChange)="agreedsaleskpichange($event, i)">
                                </div>

                                <!-- Agreed Receipts -->
                                <div class="kpi-field">
                                    <label class="kpi-label">Agreed Receipts</label>
                                    <input type="number" class="form-control" [(ngModel)]="c.agreed_receipts_kpi"
                                        (ngModelChange)="agreedreceipkpitchange($event, i)">
                                </div>

                                <!-- Active Qualified -->
                                <div class="kpi-field">
                                    <label class="kpi-label">Active Qualified</label>
                                    <div class="kpi-dual-input">
                                        <input type="number" class="form-control" placeholder="Count"
                                            [(ngModel)]="c.active_qualified_count"
                                            (ngModelChange)="activequalifiedprcgchange($event, i)">
                                        <input type="number" class="form-control" [(ngModel)]="c.active_qualified_kpi"
                                            (ngModelChange)="activequalifiedkpichange($event, i)">
                                    </div>
                                </div>

                                <!-- Active Lead -->
                                <div class="kpi-field">
                                    <label class="kpi-label">Active Lead</label>
                                    <div class="kpi-dual-input">
                                        <input type="number" class="form-control" placeholder="Count"
                                            [(ngModel)]="c.active_leads_count"
                                            (ngModelChange)="activeLeadcount($event, i)">
                                        <input type="number" class="form-control" [(ngModel)]="c.active_leads_kpi"
                                            (ngModelChange)="activeLeadkpi($event, i)">
                                    </div>
                                </div>

                                <!-- Non Qualified → Qualified -->
                                <div class="kpi-field">
                                    <label class="kpi-label">Non Qualified → Qualified</label>
                                    <div class="kpi-dual-input">
                                        <input type="number" class="form-control" placeholder="Count"
                                            [(ngModel)]="c.non_qualified_to_qualified_count"
                                            (ngModelChange)="activenoqualifiedprcngchange($event, i)">
                                        <input type="number" class="form-control"
                                            [(ngModel)]="c.non_qualified_to_qualified_kpi"
                                            (ngModelChange)="activenoqualifiedkpichange($event, i)">
                                    </div>
                                </div>

                                <!-- Overdue Inactive -->
                                <div class="kpi-field">
                                    <label class="kpi-label">Overdue Inactive</label>
                                    <div class="kpi-dual-input">
                                        <input type="number" class="form-control" placeholder="%"
                                            [(ngModel)]="c.overdue_inactive_percentage"
                                            (ngModelChange)="averagenonsaleprcngchange($event, i)">
                                        <input type="number" class="form-control" [(ngModel)]="c.overdue_inactive_kpi"
                                            (ngModelChange)="averagenonsaleskpichange($event, i)">
                                    </div>
                                </div>

                                <!-- Total Overdue Customer KPI -->
                                <div class="kpi-field">
                                    <label class="kpi-label">Total Overdue Customer KPI</label>
                                    <input type="number" class="form-control" [(ngModel)]="c.total_overdue_customer_kpi"
                                        (ngModelChange)="updateValue($event, i)">
                                </div>

                                <!-- Total Overdue Customer Target -->
                                <div class="kpi-field">
                                    <label class="kpi-label">Total Overdue Customer Target</label>
                                    <input type="number" class="form-control"
                                        [(ngModel)]="c.total_overdue_customer_target"
                                        (ngModelChange)="updateValue1($event, i)">
                                </div>

                            </div>
                        </div>
                        <!-- end card body -->

                    </div>
                    <!-- end *ngFor -->
                </div>
                <!-- end kpi-cards-wrapper -->

            </div>
        </mat-tab>


        <!--
  Also replace the modal div (id="modal-sm3") with this.
-->

        <div class="modal fade" id="modal-sm3" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content kpi-modal-content">

                    <div class="modal-header kpi-modal-header">
                        <h5 class="modal-title">Add Monthly KPI</h5>
                    </div>

                    <div class="modal-body kpi-modal-body">
                        <div class="kpi-grid">

                            <!-- Month -->
                            <div class="kpi-field full-width">
                                <label class="kpi-label">Month <span class="text-danger">*</span></label>
                                <input type="month" class="form-control" [(ngModel)]="data1.month"
                                    [min]="getCurrentMonth()">
                            </div>

                            <!-- Agreed Sales -->
                            <div class="kpi-field">
                                <label class="kpi-label">Agreed Sales</label>
                                <input type="number" class="form-control" [(ngModel)]="data1.agreed_sales_kpi">
                            </div>

                            <!-- Agreed Receipts -->
                            <div class="kpi-field">
                                <label class="kpi-label">Agreed Receipts</label>
                                <input type="number" class="form-control" [(ngModel)]="data1.agreed_receipts_kpi">
                            </div>

                            <!-- Active Qualified -->
                            <div class="kpi-field">
                                <label class="kpi-label">Active Qualified</label>
                                <div class="kpi-dual-input">
                                    <input type="number" class="form-control" placeholder="Count"
                                        [(ngModel)]="data1.active_qualified_count">
                                    <input type="number" class="form-control" [(ngModel)]="data1.active_qualified_kpi">
                                </div>
                            </div>

                            <!-- Active Lead -->
                            <div class="kpi-field">
                                <label class="kpi-label">Active Lead</label>
                                <div class="kpi-dual-input">
                                    <input type="number" class="form-control" placeholder="Count"
                                        [(ngModel)]="data1.active_leads_count">
                                    <input type="number" class="form-control" [(ngModel)]="data1.active_leads_kpi">
                                </div>
                            </div>

                            <!-- Non Qualified → Qualified -->
                            <div class="kpi-field">
                                <label class="kpi-label">Non Qualified → Qualified</label>
                                <div class="kpi-dual-input">
                                    <input type="number" class="form-control" placeholder="Count"
                                        [(ngModel)]="data1.non_qualified_to_qualified_count">
                                    <input type="number" class="form-control"
                                        [(ngModel)]="data1.non_qualified_to_qualified_kpi">
                                </div>
                            </div>

                            <!-- Overdue Inactive -->
                            <div class="kpi-field">
                                <label class="kpi-label">Overdue Inactive</label>
                                <div class="kpi-dual-input">
                                    <input type="number" class="form-control" placeholder="%"
                                        [(ngModel)]="data1.overdue_inactive_percentage">
                                    <input type="number" class="form-control" [(ngModel)]="data1.overdue_inactive_kpi">
                                </div>
                            </div>

                            <!-- Total Overdue Customer KPI -->
                            <div class="kpi-field">
                                <label class="kpi-label">Total Overdue Customer KPI</label>
                                <input type="number" class="form-control"
                                    [(ngModel)]="data1.total_overdue_customer_kpi">
                            </div>

                            <!-- Total Overdue Customer Target -->
                            <div class="kpi-field">
                                <label class="kpi-label">Total Overdue Customer Target</label>
                                <input type="number" class="form-control"
                                    [(ngModel)]="data1.total_overdue_customer_target">
                            </div>

                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal"
                            (click)="KpiSubmit()">Submit</button>
                    </div>

                </div>
            </div>
        </div>

        <!-----------------------------------start--------------------------------------------->
        <mat-tab label="Leave Management">

            <div class="card card-primary card-outline style">
                <div class="card-body box-profile">

                    <p>
                        <b>Leave Management</b>
                    </p>


                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-6">

                                <div class="form-group">
                                    <label>Year</label>
                                    <select #teams class="form-control select2 select2-hidden-accessible"
                                        style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true"
                                        #mySelectYear (change)='YearSelected(mySelectYear.value)'>
                                        <option>2023</option>
                                        <option>2024</option>
                                        <option>2025</option>
                                        <option>2026</option>
                                    </select>
                                </div>


                                <div class="form-group">
                                    <label *ngIf="calenderShown">Vocation</label>
                                    <mat-form-field *ngIf="calenderShown">
                                        <ngx-multiple-dates [matDatepicker]="picker" placeholder="Select Dates"
                                            name="excludedDates" [(ngModel)]="model" [min]="minDate" [max]="maxDate">
                                        </ngx-multiple-dates>
                                        <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                            </div>



                            <div class="col-md-6">

                                <div class="form-group">
                                    <label>Month</label><span class="error">{{MName}}</span>
                                    <select #teams class="form-control select2 select2-hidden-accessible"
                                        style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true"
                                        #mySelectMonth (change)='MonthSelected(mySelectMonth.value)'>
                                        <option selected="selected" data-select2-id="1" hidden>Select</option>
                                        <option *ngFor="let d of Month;index as i" data-select2-id="2" [value]="i">
                                            {{d.name}}</option>

                                    </select>
                                </div>



                                <div class="form-group">
                                    <label *ngIf="calenderShown">Sick leave</label>
                                    <mat-form-field *ngIf="calenderShown">
                                        <ngx-multiple-dates [matDatepicker]="picker" placeholder="Select Dates"
                                            name="excludedDates1" [(ngModel)]="model1" [min]="minDate" [max]="maxDate">
                                        </ngx-multiple-dates>
                                        <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>



                            </div>
                        </div>



                        <!-- <mat-form-field *ngIf="calenderShown">
                          <ngx-multiple-dates [matDatepicker]="picker" placeholder="Select Dates" name="excludedDates"
                                              [(ngModel)]="model" [min]="minDate" [max]="maxDate">
                          </ngx-multiple-dates>
                          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field> -->

                        <br>


                        <button type="submit" class="btn btn-primary btn_allign"
                            (click)="SubmitLeave(); notification();">Submit</button>

                    </div>


                </div>
            </div>

        </mat-tab>
        <mat-tab label="Attendance Management">
            <div class="card-body">
                <form class="form-data" [formGroup]="creationForm" (ngSubmit)="submitAttendance()">

                    <section class="main-page-box">
                        <div class="row">
                            <div class="col-12 col-sm-8 col-md-6">
                                <div class="row">
                                    <div class="col-12">
                                        <label for="workin_time" class="required">Work in time</label>
                                        <input class="form-control" name="workin_time" type="time" id="workin_time"
                                            formControlName="workin_time">
                                        <div *ngIf="creationForm.get('workin_time')?.invalid && creationForm.get('workin_time')?.touched"
                                            class="text-danger">
                                            Work In Time is required
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label for="is_department_specific" class="required boxcheck">Is department
                                            Specific</label>
                                        <input class="form" type="checkbox" value="" id="is_department_specific"
                                            name="is_department_specific" formControlName="is_department_specific"
                                            class="mt-1">
                                        <div *ngIf="creationForm.get('is_department_specific')?.invalid && creationForm.get('is_department_specific')?.touched"
                                            class="text-danger">
                                            Department Specific is Required
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label for="is_location_restricted" class="required">Weekly Working Day</label>
                                        <div *ngFor="let day of weeKDays; let i = index">
                                            <mat-checkbox [checked]="day.checked" (change)="weekSelected(i+1)">
                                                {{ day.week }}
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div class="col-12 col-sm-8 col-md-6">
                                <div class="row">

                                    <div class="col-12">
                                        <label for="workout_time" class="required">Work out time</label>
                                        <input class="form-control" type="time" name="workout_time" id="workout_time"
                                            formControlName="workout_time">
                                        <div *ngIf="creationForm.get('workout_time')?.invalid && creationForm.get('workout_time')?.touched"
                                            class="text-danger">
                                            Work out time is Required
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label for="is_location_restricted" class="required boxcheck">Is location
                                            restricted</label>
                                        <input class="form" type="checkbox" value="" id="is_location_restricted"
                                            name="is_location_restricted" formControlName="is_location_restricted">
                                        <div *ngIf="creationForm.get('is_location_restricted')?.invalid && creationForm.get('is_location_restricted')?.touched"
                                            class="text-danger">
                                            Location Specific Required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div class="d-flex justify-content-start ">

                        <button type="submit" class="btn btn-primary btn_allign">Submit</button>
                    </div>
                </form>
            </div>
        </mat-tab>

        <!------------------------------------end----------------------------------------------->

    </mat-tab-group>



    <div class="modal fade" id="modal-sm3" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content kpi-modal-content">

                <!-- Modal Header -->
                <div class="modal-header kpi-modal-header">
                    <h5 class="modal-title">Monthly KPI</h5>
                </div>

                <!-- Modal Body -->
                <div class="modal-body kpi-modal-body">
                    <div class="kpi-grid">

                        <!-- Month -->
                        <div class="kpi-field full-width">
                            <label class="kpi-label">Month <span class="text-danger">*</span></label>
                            <input type="month" class="form-control" [(ngModel)]="data1.month"
                                [min]="getCurrentMonth()">
                        </div>

                        <!-- Agreed Sales -->
                        <div class="kpi-field">
                            <label class="kpi-label">Agreed Sales</label>
                            <input type="number" class="form-control" [(ngModel)]="data1.agreed_sales_kpi">
                        </div>

                        <!-- Agreed Receipts -->
                        <div class="kpi-field">
                            <label class="kpi-label">Agreed Receipts</label>
                            <input type="number" class="form-control" [(ngModel)]="data1.agreed_receipts_kpi">
                        </div>

                        <!-- Active Qualified -->
                        <div class="kpi-field">
                            <label class="kpi-label">Active Qualified</label>
                            <div class="kpi-dual-input">
                                <input type="number" class="form-control" placeholder="Count"
                                    [(ngModel)]="data1.active_qualified_count">
                                <input type="number" class="form-control" [(ngModel)]="data1.active_qualified_kpi">
                            </div>
                        </div>

                        <!-- Active Lead -->
                        <div class="kpi-field">
                            <label class="kpi-label">Active Lead</label>
                            <div class="kpi-dual-input">
                                <input type="number" class="form-control" placeholder="Count"
                                    [(ngModel)]="data1.active_leads_count">
                                <input type="number" class="form-control" [(ngModel)]="data1.active_leads_kpi">
                            </div>
                        </div>

                        <!-- Non Qualified to Qualified -->
                        <div class="kpi-field">
                            <label class="kpi-label">Non Qualified → Qualified</label>
                            <div class="kpi-dual-input">
                                <input type="number" class="form-control" placeholder="Count"
                                    [(ngModel)]="data1.non_qualified_to_qualified_count">
                                <input type="number" class="form-control"
                                    [(ngModel)]="data1.non_qualified_to_qualified_kpi">
                            </div>
                        </div>

                        <!-- Overdue Inactive -->
                        <div class="kpi-field">
                            <label class="kpi-label">Overdue Inactive</label>
                            <div class="kpi-dual-input">
                                <input type="number" class="form-control" placeholder="%"
                                    [(ngModel)]="data1.overdue_inactive_percentage">
                                <input type="number" class="form-control" [(ngModel)]="data1.overdue_inactive_kpi">
                            </div>
                        </div>

                        <!-- Total Overdue Customer KPI -->
                        <div class="kpi-field">
                            <label class="kpi-label">Total Overdue Customer KPI</label>
                            <input type="number" class="form-control" [(ngModel)]="data1.total_overdue_customer_kpi">
                        </div>

                        <!-- Total Overdue Customer Target -->
                        <div class="kpi-field">
                            <label class="kpi-label">Total Overdue Customer Target</label>
                            <input type="number" class="form-control" [(ngModel)]="data1.total_overdue_customer_target">
                        </div>

                    </div>
                </div>

                <!-- Modal Footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal"
                        (click)="KpiSubmit()">Submit</button>
                </div>

            </div>
        </div>
    </div>
</div>




<!------------------------------old ui-------------------------------------
<form class="center">
    <h1> Edit Employee Details</h1>
</form>

    <div class="card-body" *ngFor="let c of output">
        <div class="row">
        <div class="col-md-6">

      
        <div class="form-group">
            <label>Code</label>
            <input type="text" class="form-control"  name="code" [(ngModel)]="data.employee_code">
        </div>
        <div class="form-group">
            <label>Role</label>
            <input type="text" class="form-control"  name="role" [(ngModel)]="data.role">
        </div>
        <div class="form-group">
            <label>Monthly Receipt Target</label>
            <input type="number" class="form-control"  name="receiptTarget" [(ngModel)]="data.monthly_receipts_target">
        </div>
        <div class="form-group">
            <label>Yearly Receipt Target</label>
            <input type="number" class="form-control"  name="receiptTarget" [(ngModel)]="data.current_year_receipt_target">
        </div>
        <div class="form-group">
            <label>Today Visit Target</label>
            <input type="number" class="form-control"  name="todayTarget" [(ngModel)]="data.today_visit_target">
        </div>
        <div class="form-group">
            <label>Current Month Visit Target</label>
            <input type="number" class="form-control"  name="monthTarget" [(ngModel)]="data.current_month_visits_target">
        </div>
    ---------------upload image--------------------------------------

    <div class="form-group">
        <label>Image</label>
        <input type="search" class="form-control"  name="role" [(ngModel)]="name" (change)="RemoveFile()">
    </div>
    <div class="custom-file">
    <input #imageInput type="file" class="custom-file-input" id="customFile" accept="image/*" (change)="processFile(imageInput)" [(ngModel)]="currentInput">
    <label class="custom-file-label" for="customFile">{{currentInput}}</label>
    </div>
    <--------------
    <img [src]=url height="200"> <br/>
    --------------------------------------------->
<!--------------------------------------------------------------------
        </div>
        
        <div class="col-md-6">
        <div class="form-group">
       

            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control"  name="name" [(ngModel)]="data.employee_name">
            </div>
        </div>
        
        <div class="form-group">
            <div class="form-group">
                <label>Email</label><span class="error">{{EmailAlert}}</span>
                <input type="email" class="form-control"  name="email" [(ngModel)]="data.email_address" [formControl]="email" (ngModelChange)="valuechange1($event)">
            </div>
        </div>
        <div class="form-group">
            <div class="form-group">
                <label>Monthly Sales Target</label>
                <input type="number" class="form-control"  name="invoiceTarget" [(ngModel)]="data.monthly_invoice_target">
            </div>
        </div>

        <div class="form-group">
            <div class="form-group">
                <label>Yearly Sales Target</label>
                <input type="number" class="form-control"  name="invoiceTarget" [(ngModel)]="data.current_year_sales_target">
            </div>
        </div>
        
        <div class="form-group">
            <div class="form-group">
                <label>Department</label>
            </div>
           <select  #teams (change)="onSelected(teams.value)" class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.department">
            <option selected="selected" data-select2-id="1">{{data.department}}</option>
            <option *ngFor="let d of department" data-select2-id="2" [value]="d.department_id">{{d.department_name}}</option>
            <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
            </select> 
        </div>
        <--------------------------------------------------------
        <div class="form-group">
            <div class="form-group">
                <label>Brand</label>
            </div>
           <select class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.employee_brand">
            <option selected="selected" data-select2-id="1">{{data.employee_brand}}</option>
            <option *ngFor="let d of brand" data-select2-id="2" >{{d.brand_name}}</option>
            <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
            </select> 
        </div>
        <----------------------------------------------------------
        </div>
        
        </div>
        
        </div>
        
          <div class="sucess" *ngIf="isShown">
            <span class="closebtn content" onclick="this.parentElement.style.display='none';">&times;</span> 
            {{alert}}
          </div><br>

        <button type="submit" class="btn btn-primary btn_allign" (click)="btnClick(); notification();">Submit</button>

--------------------------------------------->